'use strict';

var React = require('react');

var SvgMetaobjectReferenceMinor = function SvgMetaobjectReferenceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3.5v1.5h-.5a1 1 0 0 0-1 1v4c0 .086.01.17.031.25-.02.08-.031.164-.031.25v.75a.75.75 0 0 0 1.5 0v-.25h12v3.75h-6.25a.75.75 0 0 0 0 1.5h6.75a1 1 0 0 0 1-1v-4.75a1 1 0 0 0-1-1h-.5v-1.5a1 1 0 0 0-1-1h-2.5a1 1 0 0 0-1 1v1.5h-1.5v-3.5a1 1 0 0 0-1-1h-.5v-1.5a1 1 0 0 0-1-1h-2.5a1 1 0 0 0-1 1Zm1.5.5v1h1.5v-1h-1.5Zm3 2.5v3h-4.5v-3h4.5Zm4.5 3h1.5v-1h-1.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5a2.75 2.75 0 0 1 2.75-2.75h1.44l-.47-.47a.75.75 0 1 1 1.06-1.06l1.75 1.75a.75.75 0 0 1 0 1.06l-1.75 1.75a.75.75 0 0 1-1.06-1.06l.47-.47h-1.44Z"
  }));
};
SvgMetaobjectReferenceMinor.displayName = "MetaobjectReferenceMinor";

exports.SvgMetaobjectReferenceMinor = SvgMetaobjectReferenceMinor;
